var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8132 24.8944C48.9915 37.926 38.5719 48.6347 25.5403 48.813C12.5086 48.9913 1.7999 38.5717 1.62159 25.5401C1.44328 12.5085 11.8629 1.79973 24.8945 1.62142C37.9261 1.44311 48.6349 11.8628 48.8132 24.8944Z",
    stroke: "#9D34DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 32.9997C31 34.6479 29.1184 35.5886 27.7999 34.5997L17.1332 26.5987C16.0666 25.7987 16.0667 24.1987 17.1334 23.3987L27.8001 15.3997C29.1186 14.4109 31 15.3517 31 16.9997L31 32.9997Z",
    fill: "#9D34E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleBtn);
export default __webpack_public_path__ + "static/media/TriangleBtn.168e1a64cd3d098a3f4d842b4f00b48b.svg";
export { ForwardRef as ReactComponent };